module.exports = __webpack_public_path__ + "static/media/alpha_21.559227c2.png";